/** Payload gravado com a mensagem, que o backend devolve como texto JSON. Nulo quando não dá para ler. */
export const getPayloadObject = (payload) => {
    if (!payload) return null;
    if (typeof payload === "object") return payload;
    try {
        return JSON.parse(payload);
    } catch {
        return null;
    }
};

/**
 * Texto da mensagem para exibir na tela. Modelo e mensagem interativa não trazem o texto no payload,
 * então vêm do texto completo gravado no histórico. A prévia é cortada em 250 caracteres e só serve
 * para os registros anteriores a esse campo, de antes de 20/10/2026.
 */
export const getMessageBody = (log) => {
    const payloadObject = getPayloadObject(log.payload);
    return payloadObject?.text?.body
        || payloadObject?.entry?.[0]?.changes?.[0]?.value?.messages?.[0]?.text?.body
        || log.body
        || log.bodyPreview
        || "-";
};
